<template>
  <div>
    <div class="text-right">
      <!-- <span
        class="material-icons-outlined small_icon cursor-pointer"
        @click="editBox = true"
        >border_color</span
      > -->
      <vs-tooltip class="inline-block" position="top" color="primary" text="Edit" v-if="!editBox">
        <vs-button class="block ml-auto" icon="border_color" type="border" @click="canEdit()" >
        <!-- <span class="material-icons-outlined small_icon cursor-pointer" ></span> -->
        </vs-button>
      </vs-tooltip>
    </div>

    <vs-row v-if="!editBox">
      <template v-for="(dynamicfield, index) in dynamicfields">
        <vs-col vs-lg="6" vs-sm="12" class="p-1" :key="`${index}`">
          <p>{{ dynamicfield.name }}:</p>
        </vs-col>
        <vs-col
          :key="`s${index}`"
          vs-lg="6"
          vs-sm="12"
          class="p-1"
          v-if="dynamicfield.is_collection === false"
        >
          <p v-if="dynamicfield.inputtype === 'datetime'">
            {{ clientDetails[dynamicfield.field] | dateFormatLocalization }}
          </p>
          <p v-else>
            {{ clientDetails[dynamicfield.field] || "not available" }}
          </p>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="p-1" v-else :key="`${index}`">
          <div
            v-for="(element, index) in clientDetails[dynamicfield.field]"
            :key="index"
          >
            <span> {{ element }}</span> 
            <span v-if="(clientDetails[dynamicfield.field].length - 1) !== index">, </span>
          </div>
        </vs-col>
      </template>
    </vs-row>
    <vs-row v-else>
      <template v-for="(custom_field, index) in custom_fields">
        <vs-col
          vs-lg="12"
          vs-sm="12"
          class="p-1"
          :key="custom_field.attribute_id"
        >
          <!-- To Check Text Field -->
          <label
            v-if="custom_field.inputtype === 'text'"
            class="vs-input--label"
          >
            {{ custom_field.label }}
            <span :class="custom_field.is_required ? 'required' : ''"> </span>
          </label>
          <vs-input
            v-if="custom_field.inputtype === 'text'"
            :placeholder="custom_field.label"
            class="w-full"
            v-validate="custom_field.is_required ? 'required' : ''"
            v-model="dynamicform[custom_field.field]"
            :data-vv-name="`${custom_field.label}`"
            :name="`${custom_field.label}`"
          />

          <div
            v-if="
              errors.has(`add.${custom_field.label}`) &&
              custom_field.inputtype === 'text'
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first(`add.${custom_field.label}`) }}
          </div>
          <!-- To Check Text Field -->

          <label
            class="vs-input--label"
            v-if="custom_field.inputtype === 'number'"
          >
            {{ custom_field.label }}
            <span :class="custom_field.is_required ? 'required' : ''"> </span>
          </label>
          <vs-input
            v-if="custom_field.inputtype === 'number'"
            class="w-full"
            v-validate="custom_field.is_required ? 'required|numeric' : ''"
            v-model="dynamicform[custom_field.field]"
            :data-vv-name="`${custom_field.label}`"
            :name="`${custom_field.label}`"
          />
          <div
            v-if="
              errors.has(`add.${custom_field.label}`) &&
              custom_field.inputtype === 'number'
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first(`add.${custom_field.label}`) }}
          </div>
          <!-- To Check Number Field -->

          <!-- To Check Text Area Field -->
          <label
            class="vs-input--label"
            v-if="custom_field.inputtype === 'textarea'"
          >
            {{ custom_field.label }}
            <span :class="custom_field.is_required ? 'required' : ''"> </span>
          </label>
          <vs-textarea
            v-if="custom_field.inputtype === 'textarea'"
            :placeholder="custom_field.label"
            class="w-full"
            v-validate="custom_field.is_required ? 'required' : ''"
            :data-vv-name="`${custom_field.label}`"
            :name="`${custom_field.label}`"
            v-model="dynamicform[custom_field.field]"
            onkeypress="return (event.charCode >= 65 && event.charCode <= 90) ||
                  (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32) || (event.charCode == 08)"
          />
          <div
            v-if="
              errors.has(`add.${custom_field.label}`) &&
              custom_field.inputtype === 'textarea'
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first(`add.${custom_field.label}`) }}
          </div>
          <!-- To Check TextArea Field -->

          <!-- To Check Checkbox Field -->
          <div v-if="custom_field.inputtype === 'checkbox'">
            <span>{{ custom_field.label }}</span>
            <span :class="custom_field.is_required ? 'required' : ''"></span>

            <vs-checkbox
              v-validate="custom_field.is_required ? 'required' : ''"
              v-for="multivalue in custom_field.multivalue"
              :key="multivalue.id"
              :data-vv-name="`${custom_field.label}`"
              :name="`${custom_field.label}`"
              v-model="dynamicform[custom_field.field]"
              :vs-value="multivalue.optionsvaluename"
            >
              {{ multivalue.optionsvaluename }}
            </vs-checkbox>
            <div
              v-if="
                errors.has(`add.${custom_field.label}`) &&
                custom_field.inputtype === 'checkbox'
              "
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first(`add.${custom_field.label}`) }}
            </div>
          </div>
          <!-- To Check Checkbox Field -->

          <!-- To Check Radio Field -->
          <template v-if="custom_field.inputtype === 'radio'">
            <label class="vs-input--label">
              {{ custom_field.label }}

              <span :class="custom_field.is_required ? 'required' : ''"></span>
            </label>
            <br />
            <ul class="ml-2">
              <li
                v-for="multivalue in custom_field.multivalue"
                :key="multivalue.id"
              >
                <vs-radio
                  v-validate="custom_field.is_required ? 'required' : ''"
                  id="radiodynamic"
                  v-model="dynamicform[custom_field.field]"
                  :vs-name="`custom_field.label${index}`"
                  :data-vv-name="`${custom_field.label}`"
                  :name="`${custom_field.label}`"
                  :vs-value="multivalue.optionsvaluename"
                >
                  {{ multivalue.optionsvaluename }}
                </vs-radio>
              </li>
            </ul>

            <div
              v-if="
                errors.has(`add.${custom_field.label}`) &&
                custom_field.inputtype === 'radio'
              "
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first(`add.${custom_field.label}`) }}
            </div>
          </template>

          <!-- radio button -->

          <!-- To Check Boolean Field -->
          <template v-if="custom_field.inputtype === 'boolean'">
            <label class="vs-input--label">
              {{ custom_field.label }}

              <span :class="custom_field.is_required ? 'required' : ''"></span>
            </label>
            <br />

            <ul class="ml-2">
              <li>
                <vs-radio
                  v-validate="custom_field.is_required ? 'required' : ''"
                  id="radiodynamic"
                  v-model="dynamicform[custom_field.field]"
                  :vs-name="`custom_field.label${index}`"
                  :data-vv-name="`${custom_field.label}`"
                  :name="`${custom_field.label}`"
                  :vs-value="true"
                >
                  True
                </vs-radio>
                <br />
                <vs-radio
                  v-validate="custom_field.is_required ? 'required' : ''"
                  id="radiodynamic"
                  v-model="dynamicform[custom_field.field]"
                  :vs-name="`custom_field.label${index}`"
                  :data-vv-name="`${custom_field.label}`"
                  :name="`${custom_field.label}`"
                  :vs-value="false"
                >
                  False
                </vs-radio>
              </li>
            </ul>
            <div
              v-if="
                errors.has(`add.${custom_field.label}`) &&
                custom_field.inputtype === 'boolean'
              "
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first(`add.${custom_field.label}`) }}
            </div>
          </template>
          <!-- boolean -->

          <!-- To Check Date Field -->
          <template v-if="custom_field.inputtype === 'datetime'">
            <label class="vs-input--label">
              {{ custom_field.label }}

              <span :class="custom_field.is_required ? 'required' : ''"></span>
            </label>
            <br />

            <ul>
              <flat-pickr
                class="w-full"
                v-validate="custom_field.is_required ? 'required' : ''"
                :class="{
                  input: true,
                  'is-danger': errors.has(`${custom_field.label}`),
                }"
                :config="{
                  altInput: true,
                  altFormat: 'j F, Y',
                  dateFormat: 'Y-m-d',
                }"
                :data-vv-name="`${custom_field.label}`"
                :name="`${custom_field.label}`"
                v-model="dynamicform[custom_field.field]"
              />
            </ul>

            <div
              v-if="
                errors.has(`add.${custom_field.label}`) &&
                custom_field.inputtype === 'datetime'
              "
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first(`add.${custom_field.label}`) }}
            </div>
          </template>

          <!--To Check datefield-->

          <!-- To Check Select Field -->
          <template v-if="custom_field.inputtype === 'select'">
            <label class="vs-input--label">
              {{ custom_field.label }}

              <span :class="custom_field.is_required ? 'required' : ''"></span>
            </label>
            <vs-select
              v-if="custom_field.inputtype === 'select'"
              autocomplete
              v-validate="custom_field.is_required ? 'required' : ''"
              :data-vv-name="`${custom_field.label}`"
              :name="`${custom_field.label}`"
              class="selectExample"
              v-model="dynamicform[custom_field.field]"
            >
              <vs-select-item
                :key="multivalue.id"
                :value="multivalue.optionsvaluename"
                :text="multivalue.optionsvaluename"
                v-for="multivalue in custom_field.multivalue"
              />
            </vs-select>
          </template>

          <div
            v-if="
              errors.has(`add.${custom_field.label}`) &&
              custom_field.inputtype === 'select'
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first(`add.${custom_field.label}`) }}
          </div>

          <template v-if="custom_field.inputtype === 'multiselect'">
            <label class="vs-input--label">
              {{ custom_field.label }}

              <span :class="custom_field.is_required ? 'required' : ''"></span>
            </label>
            <v-select
              multiple
              :data-vv-name="`${custom_field.label}`"
              :name="`${custom_field.label}`"
              label="optionsvaluename"
              v-validate="custom_field.is_required ? 'required' : ''"
              :closeOnSelect="false"
              v-model="dynamicform[custom_field.field]"
              :reduce="(option) => option.optionsvaluename"
              :options="custom_field.multivalue"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            /><br />
          </template>
          <div
            v-if="
              errors.has(`add.${custom_field.label}`) &&
              custom_field.inputtype === 'multiselect'
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first(`add.${custom_field.label}`) }}
          </div>
          <!-- To Check MultiSelect Field -->

          <!-- For Dynamic Field required Labels-->
        </vs-col>
      </template>
      <vs-col vs-w="12" v-if="editBox" class="mt-4 text-right">
        <vs-button
          class="mr-2"
          type="border"
          color="danger"
          @click="editBox = false"
          >Cancel</vs-button
        >
        <vs-button @click="updateBasicDetail">Save</vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import { StudentMixins } from '@/views/pages/v1/StudentProfile/mixins/studentMixin.js'

import { Fragment } from 'vue-fragment'
import { fetchCustomFields } from '@/api/customfield'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  mixins: [StudentMixins],
  components: {
    Fragment,
    flatPickr,
    vSelect
  },
  mounted () {
    this.fetchCustomField()
  },
  props: {
    clientDetails: {
      default: []
    }
  },
  data () {
    return {
      editBox: false,
      dynamicform: {},
      custom_fields: [],
      dynamicfields: []
    }
  },
  methods: {
    canEdit () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editBox = true
    },
    async fetchCustomField () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields('Client', customerId)

        this.custom_fields = data.data.custom_fields

        for (let i = 0; i < this.custom_fields.length; i++) {
          if (
            this.custom_fields[i].inputtype === 'checkbox' ||
            this.custom_fields[i].inputtype === 'multiselect'
          ) {
            let temp = []
            if (this.clientDetails[this.custom_fields[i].field]) {
              temp = this.clientDetails[this.custom_fields[i].field]
            }
            this.$set(this.dynamicform, this.custom_fields[i].field, temp)
          } else {
            this.dynamicform[this.custom_fields[i].field] =
              this.clientDetails[this.custom_fields[i].field]
          }
        }

        const dynamicfieldsarr = data.data.custom_fields.map((item) => {
          const container = {}
          container['name'] = item.label
          container['field'] = item.field
          container['is_collection'] = item.is_collection
          container['inputtype'] = item.inputtype

          return container
        })

        this.dynamicfields = dynamicfieldsarr
      } catch (e) {
        //
      }
    },
    updateBasicDetail () {
      this.$validator.validateAll('add').then((valid) => {
        if (valid) {
          this.UpdateDetails(this.clientDetails.basic_details.client_users_id)
          this.editBox = false
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'All required fields are mandatory',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      })
    }
  }
}
</script>
